import {
  IOffer as IOfferMobile,
  OfferCardMobileWidgetContainer as OfferCardMobileWidget,
} from '../../../../../packages/OfferCardMobileWidget';
import { useSelector } from 'react-redux';
import { selectOffers } from 'shared/selectors/offers';
import { selectUser } from 'shared/selectors/user';
import { useApplicationContext } from 'shared/utils/applicationContext';
import { selectHouseId } from 'shared/selectors/houseInfo';
import {
  trackChatButtonClick,
  trackChatPopupOpen,
  trackFavoritesChange,
  trackOfferCardClick,
  trackPhoneShow,
} from '../../tracking';
import { useEventCallback } from '@cian/react-utils';

export const OffersContainerMobile = () => {
  const context = useApplicationContext();
  const user = useSelector(selectUser);
  const offers = useSelector(selectOffers) as IOfferMobile[];
  const houseId = useSelector(selectHouseId);

  const getOfferTracking = useEventCallback((offer: IOfferMobile, index: number) => {
    const commonProps = {
      offerId: offer.id,
      position: index + 1,
      houseId,
      label: offer.gaLabel ?? /* istanbul ignore next */ '',
    };
    const ownerId = offer.author?.cianId;

    return {
      onCardClick: trackOfferCardClick,
      onPhoneShow: () => trackPhoneShow(commonProps),
      onChatButtonClick: () => trackChatButtonClick({ ...commonProps, ownerId }),
      onChatPopupOpen: () => trackChatPopupOpen({ ...commonProps, ownerId }),
      onFavoritesAdd: () => trackFavoritesChange({ ...commonProps, isAdded: true, isMobile: true }),
      onFavoritesRemove: () => trackFavoritesChange({ ...commonProps, isAdded: false, isMobile: true }),
    };
  });

  return (
    <div>
      {offers.map((offer, index) => (
        <OfferCardMobileWidget
          key={offer.id}
          offer={offer}
          user={user}
          context={context}
          {...getOfferTracking(offer, index)}
        />
      ))}
    </div>
  );
};
